<template>
  <social-sharing
    :url="currentPage.link"
    :title="currentPage.title.rendered"
    :description="currentPage.post_excerpt"
    inline-template
    class="share-block share-line"
  >
    <div class="social-links">
      <span class="text">Del gjerne!</span>
      <network network="facebook">
        <span v-html="svgIcons.facebook"></span>
      </network>
      <network network="linkedin">
        <span v-html="svgIcons.linked_in"></span>
      </network>
      <network network="twitter">
        <span v-html="svgIcons.twitter"></span>
      </network>
    </div>
  </social-sharing>
</template>

<script>
import SocialSharing from "vue-social-sharing";

export default {
  name: "share-block",
  props: { id: Number },
  computed: {},
  components: {
    "social-sharing": SocialSharing
  }
};
</script>

<style lang="scss">
.share-block {
  display: flex;
  align-items: center;
  .text {
    margin-right: 15px;
  }
  span {
    display: inline-block;
  }
  svg {
    width: 32px;
    display: inline-block;
    margin-right: 10px;
    height: 32px;
    cursor: pointer;
    g {
      fill: #2a2e34;
    }
  }
}
</style>
